import { call, put, takeLatest, select } from 'redux-saga/effects';
import accessReportService from '../../../services/accessReportService';
import {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchAccessReport,
  fetchAccessReportSuccess,
  fetchAccessReportFailure,
  exportAccessReportToExcel,
  exportAccessReportToExcelSuccess,
  exportAccessReportToExcelFailure,
  exportAccessReportToPdf,
  exportAccessReportToPdfSuccess,
  exportAccessReportToPdfFailure,
  selectAccessReportFilterUnitId,
  selectAccessReportFilterFromDate,
  selectAccessReportFilterToDate,
} from './slice';

function* handleFetchInit() {
  try {
    const response = yield call(accessReportService.getInit);
    yield put(fetchInitSuccess(response));
  } catch (error) {
    yield put(fetchInitFailure(error.message || 'reports.access.errors.fetchInitFailed'));
  }
}

// Helper to check if value is empty (null, undefined, or empty string - NOT 0)
const isEmpty = (value) => value === '' || value === null || value === undefined;

function* handleFetchAccessReport() {
  try {
    // Get current filter values
    const unitId = yield select(selectAccessReportFilterUnitId);
    const fromDate = yield select(selectAccessReportFilterFromDate);
    const toDate = yield select(selectAccessReportFilterToDate);

    // Validate filters
    if (isEmpty(unitId) || isEmpty(fromDate) || isEmpty(toDate)) {
      yield put(fetchAccessReportFailure('reports.access.errors.selectFilters'));
      return;
    }

    const params = {
      unitId,
      fromDate,
      toDate,
    };

    const response = yield call(accessReportService.getAccessReport, params);
    yield put(fetchAccessReportSuccess(response));
  } catch (error) {
    yield put(fetchAccessReportFailure(error.message || 'reports.access.errors.fetchFailed'));
  }
}

function* handleExportAccessReportToExcel() {
  try {
    // Get current filter values
    const unitId = yield select(selectAccessReportFilterUnitId);
    const fromDate = yield select(selectAccessReportFilterFromDate);
    const toDate = yield select(selectAccessReportFilterToDate);

    // Validate filters (same as fetch report)
    if (isEmpty(unitId) || isEmpty(fromDate) || isEmpty(toDate)) {
      yield put(exportAccessReportToExcelFailure('reports.access.errors.selectFilters'));
      return;
    }

    const params = {
      unitId,
      fromDate,
      toDate,
    };

    yield call(accessReportService.exportAccessReportToExcel, params);
    yield put(exportAccessReportToExcelSuccess('reports.access.exportSuccess'));
  } catch (error) {
    yield put(exportAccessReportToExcelFailure(error.message || 'reports.access.errors.exportFailed'));
  }
}

function* handleExportAccessReportToPdf() {
  try {
    // Get current filter values
    const unitId = yield select(selectAccessReportFilterUnitId);
    const fromDate = yield select(selectAccessReportFilterFromDate);
    const toDate = yield select(selectAccessReportFilterToDate);

    // Validate filters (same as fetch report)
    if (isEmpty(unitId) || isEmpty(fromDate) || isEmpty(toDate)) {
      yield put(exportAccessReportToPdfFailure('reports.access.errors.selectFilters'));
      return;
    }

    const params = {
      unitId,
      fromDate,
      toDate,
      type: 'pdf',
    };

    yield call(accessReportService.exportAccessReportToExcel, params);
    yield put(exportAccessReportToPdfSuccess('reports.access.exportPdfSuccess'));
  } catch (error) {
    yield put(exportAccessReportToPdfFailure(error.message || 'reports.access.errors.exportPdfFailed'));
  }
}

export function* watchAccessReportActions() {
  yield takeLatest(fetchInit.type, handleFetchInit);
  yield takeLatest(fetchAccessReport.type, handleFetchAccessReport);
  yield takeLatest(exportAccessReportToExcel.type, handleExportAccessReportToExcel);
  yield takeLatest(exportAccessReportToPdf.type, handleExportAccessReportToPdf);
}
